'use client';

import React from 'react';

import R2Image from '@/components/ui/R2Image';

interface CloseButtonProps {
  onClick: () => void;
  iconPath?: string;
  alt?: string;
  className?: string;
  ariaLabel?: string;
  role?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  iconPath = '/images/specialists/blue-close.svg',
  alt = 'x',
  className = '',
  ariaLabel,
  role,
}) => (
  <button
    onClick={onClick}
    className={`cursor-pointer transition-opacity hover:opacity-70 ${className}`}
    type="button"
    aria-label={ariaLabel || (alt !== 'x' ? alt : 'Close')}
    role={role}
  >
    <R2Image path={iconPath} alt={alt} width={12} height={12} />
  </button>
);

export default CloseButton;
